export default "/images/vendor/flag-icon-css/flags/1x1/er.svg?ff62e2720daee288818f6277da2a1afb";